function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { __require as b } from "./conversions.js";
import { __require as q } from "./route.js";
var s, a;
function C() {
  if (a) return s;
  a = 1;
  var u = b(),
    v = q(),
    i = {},
    l = Object.keys(u);
  function f(n) {
    var r = function r() {
      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }
      var e = t[0];
      return e == null ? e : (e.length > 1 && (t = e), n(t));
    };
    return "conversion" in n && (r.conversion = n.conversion), r;
  }
  function p(n) {
    var r = function r() {
      for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        t[_key2] = arguments[_key2];
      }
      var e = t[0];
      if (e == null) return e;
      e.length > 1 && (t = e);
      var o = n(t);
      if (_typeof(o) == "object") for (var h = o.length, c = 0; c < h; c++) o[c] = Math.round(o[c]);
      return o;
    };
    return "conversion" in n && (r.conversion = n.conversion), r;
  }
  return l.forEach(function (n) {
    i[n] = {}, Object.defineProperty(i[n], "channels", {
      value: u[n].channels
    }), Object.defineProperty(i[n], "labels", {
      value: u[n].labels
    });
    var r = v(n);
    Object.keys(r).forEach(function (e) {
      var o = r[e];
      i[n][e] = p(o), i[n][e].raw = f(o);
    });
  }), s = i, s;
}
export { C as __require };